import {
  SET_APP_LANGUAGE,
  SET_LOGIN_DETAILS,
  SET_USER_PROFILE,
  SET_PROFILE_IMAGE,
  SET_ACCOUNT_LIST,
  SET_DEPOSIT_LIST,
  SET_LOAN_LIST,
  SET_LOGIN_VERIFY_DETAILS,
  SET_TXN_PENDING_COUNT,
  SET_SERVER_KEY,
  SET_SHARED_KEY,
  SET_DEVICE_ID,
  SET_MENU_OPEN,
  SET_ROLE_PERMISSION,
  SET_ACCESS_LIST,
  SET_SELECTED_ACCOUNT,
  SET_TRANSACTION_CURRENCY_LIST,
  SET_CURRENT_ACC_DETAILS,
  SET_DEFAULT_PATH,
  SET_LOGOUT,
  SET_QUICK_LINKS_DATA,
  SET_OTP_TIMER,
  SET_SESSION_TIMER,
  SET_QUICK_SEARCH,
  RESET_ALL_STATE,
  SET_COUNTRY_CODES,
} from "../constants";

export const setAppLanguage = (payload) => ({
  type: SET_APP_LANGUAGE,
  payload,
});
export const setLoginDetails = (payload) => ({
  type: SET_LOGIN_DETAILS,
  payload,
});
export const setProfileDetails = (payload) => ({
  type: SET_USER_PROFILE,
  payload,
});

export const setProfileImage = (payload) => ({
  type: SET_PROFILE_IMAGE,
  payload,
});

export const setAccountList = (payload) => ({
  type: SET_ACCOUNT_LIST,
  payload,
});

export const setDepositAccountList = (payload) => ({
  type: SET_DEPOSIT_LIST,
  payload,
});

export const setLoanAccountList = (payload) => ({
  type: SET_LOAN_LIST,
  payload,
});

export const setLoginVerifyDetails = (payload) => ({
  type: SET_LOGIN_VERIFY_DETAILS,
  payload,
});

export const setTxnPendingCount = (payload) => ({
  type: SET_TXN_PENDING_COUNT,
  payload,
});

export const setDeviceId = (payload) => ({
  type: SET_DEVICE_ID,
  payload,
});

export const setSharedKey = (payload) => ({
  type: SET_SHARED_KEY,
  payload,
});

export const setServerKey = (payload) => ({
  type: SET_SERVER_KEY,
  payload,
});

export const setMenuOpen = (payload) => ({
  type: SET_MENU_OPEN,
  payload,
});

export const setAccessList = (payload) => ({
  type: SET_ACCESS_LIST,
  payload,
});

export const setMode = (payload) => ({
  type: SET_ROLE_PERMISSION,
  payload,
});
export const setSelectedAccount = (payload) => ({
  type: SET_SELECTED_ACCOUNT,
  payload,
});

export const setTransactionCurrencyList = (payload) => ({
  type: SET_TRANSACTION_CURRENCY_LIST,
  payload,
});

export const setCurrentAccDetails = (payload) => ({
  type: SET_CURRENT_ACC_DETAILS,
  payload,
});

export const setDefaultPath = (payload) => ({
  type: SET_DEFAULT_PATH,
  payload,
});

export const setQuickLinksData = (payload) => ({
  type: SET_QUICK_LINKS_DATA,
  payload,
});

export const setMetaDataDetails = (payload) => ({
  type: SET_OTP_TIMER,
  payload,
});

export const setSessionTimeout = (payload) => ({
  type: SET_SESSION_TIMER,
  payload,
});
export const setQuickSearch = (payload) => ({
  type: SET_QUICK_SEARCH,
  payload,
});

export const setLogout = (payload) => ({ type: SET_LOGOUT, payload });

export const setResetAll = () => ({ type: RESET_ALL_STATE });

export const setCountryCodes = (payload) => ({ 
  type: SET_COUNTRY_CODES,  
  payload,
});